import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

interface PoweredByFooterProps {
  /**
   * Se true, il footer viene posizionato in assoluto in basso rispetto al
   * container padre (usato nelle pagine di login). Se false, è un normale
   * blocco in flow.
   */
  absolute?: boolean;
  /**
   * Variante cromatica:
   * - "light" → logo chiaro + testo chiaro (su sfondo scuro, es. login)
   * - "dark"  → logo scuro + testo scuro (su sfondo chiaro, es. area software)
   * Default: "light"
   */
  variant?: "light" | "dark";
  /**
   * Opacità complessiva. Default 0.55 — visibile ma discreta.
   */
  opacity?: number;
}

// Colore della barra laterale (dark navy teal)
const SIDEBAR_DARK = "#0a242e";

export const PoweredByFooter: React.FC<PoweredByFooterProps> = ({
  absolute = false,
  variant = "light",
  opacity = 0.55,
}) => {
  const isDark = variant === "dark";
  const logoSrc = isDark ? "/assets/long_dark.png" : "/assets/long_light.png";
  const textColor = isDark ? SIDEBAR_DARK : "text.secondary";

  return (
    <Box
      sx={{
        ...(absolute
          ? {
              position: "absolute",
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 2,
            }
          : { width: "100%" }),
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: "center",
        justifyContent: "center",
        gap: { xs: 0.75, sm: 1.25 },
        px: 2,
        py: 1.25,
        opacity,
        transition: "opacity 0.2s ease",
        "&:hover": { opacity: Math.min(1, opacity + 0.45) },
        pointerEvents: "auto",
      }}
    >
      <Box
        component="img"
        src={logoSrc}
        alt="EffAI"
        sx={{
          height: 16,
          objectFit: "contain",
        }}
      />
      <Typography
        variant="caption"
        sx={{
          fontSize: { xs: "0.68rem", sm: "0.72rem" },
          color: textColor,
          textAlign: "center",
          lineHeight: 1.35,
        }}
      >
        Powered by <strong>EffAI Srl SB</strong> — Consulenza e sviluppo di
        soluzioni basate su intelligenza artificiale per liberare il tempo e
        moltiplicare i risultati.
      </Typography>
    </Box>
  );
};

export default PoweredByFooter;
